import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"

export interface IGameCollectStation {
    identifier: string
    contextId: string
    name: string
    huntingDistrictId: string
    huntingDistrictName: string
}

export class GameCollectStation {

    public _structureVersion: string|undefined = undefined
    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public name: string|undefined = undefined
    public huntingDistrictId: string|undefined = undefined
    public huntingDistrictName: string|undefined = undefined
    public comment: string|undefined = undefined
    public creationDate: Date|undefined = undefined
    public updateTimestamp: Date|undefined = undefined


    constructor() {}

    setFromAny(element: any) {
        const {
            _structureVersion,
            identifier, 
            contextId,
            name, 
            comment, 
            huntingDistrictId,
            huntingDistrictName,
            creationDate, 
            updateTimestamp
        } = element

        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.name = name ? name : this.name
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
        this.comment = comment ? comment : this.comment
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
    }

    searchFilter(filter: string): boolean {
        const str = `${this.name}`.toLowerCase()
        return str.includes(filter)
    }

    replacerFn(key: string) {
        return true
    }
}